import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import WhyRestaurantsChooseUs from "./sections/WhyRestaurantsChooseUs";
import OurCoreServices from "./sections/OurCoreServices";
import SuccessStoriesPreview from "./sections/SuccessStoriesPreview";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <WhyRestaurantsChooseUs />
      <OurCoreServices />
      <SuccessStoriesPreview />
      <CallToAction />
      <Footer />
    </div>;
}